import styleInject from 'style-inject';

var css_248z = ".ErrorBox-module_container__yAf5i{background-color:var(--color-warning200);border:1px solid var(--color-warning);border-radius:var(--size--4);padding:var(--space-xs)}.ErrorBox-module_icon__dYDr0{color:var(--color-warning)}.ErrorBox-module_message__s2UaE{color:#231536}";
var styles = {"container":"ErrorBox-module_container__yAf5i","icon":"ErrorBox-module_icon__dYDr0","message":"ErrorBox-module_message__s2UaE"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRXJyb3JCb3gubW9kdWxlLnNjc3MuanMiLCJzb3VyY2VzIjpbXSwic291cmNlc0NvbnRlbnQiOltdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7OzsifQ==
